/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_CheckoutInputs */

const vi_pos_checkout = /** @type {(inputs: Pos_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán`)
};

/**

* @param {Pos_CheckoutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_checkout = /** @type {((inputs?: Pos_CheckoutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_CheckoutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_checkout(inputs)
});